import { PlusIcon } from '@heroicons/react/24/outline';
import { MetadataEntry } from '../../types/MetadataEntry';
import { createEmptyMetadataEntry } from '../../utils/jsonMetadata';
import { MetadataEntryEditor } from './MetadataEntryEditor';

type MetadataEditorProps = {
  entries: MetadataEntry[];
  onChange: (entries: MetadataEntry[]) => void;
  disabled?: boolean;
  depth?: number;
};

export function MetadataEditor({ entries, onChange, disabled = false, depth = 0 }: MetadataEditorProps) {
  function updateEntry(index: number, nextEntry: MetadataEntry): void {
    const nextEntries = [...entries];
    nextEntries[index] = nextEntry;
    onChange(nextEntries);
  }

  function removeEntry(index: number): void {
    const nextEntries = entries.filter((_, entryIndex) => entryIndex !== index);
    onChange(nextEntries);
  }

  return (
    <div className="space-y-3">
      {entries.length === 0 ? (
        <p className="rounded-lg border border-dashed border-secondary-200 px-3 py-4 text-sm text-secondary-500">
          Nenhum campo definido. Adicione pares chave-valor para descrever informações extras.
        </p>
      ) : (
        entries.map((entry, index) => (
          <MetadataEntryEditor
            key={entry.id}
            entry={entry}
            depth={depth}
            disabled={disabled}
            onChange={(nextEntry) => updateEntry(index, nextEntry)}
            onRemove={() => removeEntry(index)}
          />
        ))
      )}

      <button
        type="button"
        className="erp-btn-secondary erp-btn-sm"
        disabled={disabled}
        onClick={() => onChange([...entries, createEmptyMetadataEntry()])}
      >
        <PlusIcon className="mr-1 inline h-4 w-4" />
        Adicionar campo
      </button>
    </div>
  );
}
